import React, { useState, useEffect } from "react";
import cn from "classnames";
import styles from "./Overview.module.sass";
import Card from "../../../../components/Card";
import Actions from "../../../../components/Actions";
import Icon from "../../../../components/Icon";
import { statusFolderOpco } from "../../../../services/opco.service";
import { toast } from "react-toastify";

const Overview = ({ className, comptabilityData, folderId }) => {
  const [fraisAnnexes, setFraisAnnexes] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleGetOpcoStatus = async () => {
    if (!folderId) {
      toast.error("Aucun dossier sélectionné");
      return;
    }

    try {
      toast.info("Récupération du statut OPCO en cours...");
      const result = await statusFolderOpco(folderId);
      if (result.success) {
        toast.success("Statut OPCO récupéré avec succès");
        console.log("Statut OPCO:", result.data);
      } else {
        toast.error("Erreur lors de la récupération du statut OPCO");
      }
    } catch (error) {
      console.error("Erreur lors de la récupération du statut OPCO:", error);
      toast.error("Erreur lors de la récupération du statut OPCO");
    }
  };

  const actionsWithHandlers = [
    {
      title: "Rafraîchir le dossier",
      action: handleGetOpcoStatus,
    },
  ];

  useEffect(() => {
    if (comptabilityData && comptabilityData.engagementsFraisAnnexe) {
      // Formater les données pour l'affichage
      const formatAmount = (amount) => {
        if (!amount && amount !== 0) return "0,00€";
        return `${parseFloat(amount).toLocaleString('fr-FR', { 
          minimumFractionDigits: 2, 
          maximumFractionDigits: 2 
        })}€`;
      };

      // Créer un mapping des frais annexes depuis les engagements
      const fraisMap = {};
      comptabilityData.engagementsFraisAnnexe.forEach(frais => {
        const natureFrais = frais.natureFrais?.toLowerCase();
        if (natureFrais && frais.montantTotal !== undefined) {
          fraisMap[natureFrais] = frais.montantTotal;
        }
      });

      const fraisFormatted = [
        { 
          label: "Hébergement", 
          amount: formatAmount(fraisMap.hebergement || 0) 
        },
        { 
          label: "Premier équipement", 
          amount: formatAmount(fraisMap.premierequipement || 0) 
        },
        { 
          label: "Restauration", 
          amount: formatAmount(fraisMap.restauration || 0) 
        },
        { 
          label: "Mobilité internationale", 
          amount: formatAmount(fraisMap.mobilite || 0) 
        }
      ];

      setFraisAnnexes(fraisFormatted);
    } else {
      // Valeurs par défaut si pas de données
      setFraisAnnexes([
        { label: "Hébergement", amount: "0,00€" },
        { label: "Premier équipement", amount: "0,00€" },
        { label: "Restauration", amount: "0,00€" },
        { label: "Mobilité internationale", amount: "0,00€" }
      ]);
    }
  }, [comptabilityData]);

  if (loading) {
    return (
      <Card
        className={cn(styles.card, className)}
        title="Frais annexes"
        classTitle="title-green"
      >
        <div className={styles.overview}>
          <p>Chargement des frais annexes...</p>
        </div>
      </Card>
    );
  }

  return (
    <Card
      className={cn(styles.card, className)}
      title="Frais annexes"
      classTitle="title-green"
      head={
        <Actions
          className={styles.actions}
          classActionsHead={styles.actionsHead}
          items={actionsWithHandlers}
          small
        />
      }
    >
      <div className={styles.overview}>
        <div className={styles.fraisGrid}>
          {fraisAnnexes.map((frais, index) => (
            <div key={index} className={styles.fraisItem}>
              <div className={styles.fraisInfo}>
                <span className={styles.fraisLabel}>{frais.label}</span>
              </div>
              <span className={styles.fraisAmount}>{frais.amount}</span>
            </div>
          ))}
        </div>
      </div>
    </Card>
  );
};

export default Overview;
